
import JSEncrypt from 'jsencrypt';

const ACCESS_TOKEN_KEY = 'access_token_key';
const REFRESH_TOKEN_KEY = 'refresh_token_key';
const USERNAME_KEY = 'auth_username';
const ROLE_KEY = 'auth_role';

// Secure token storage using sessionStorage for better security
export function saveToken(accessToken, refreshToken, username, role) {
  try {
    sessionStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
    sessionStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
    sessionStorage.setItem(USERNAME_KEY, username);
    sessionStorage.setItem(ROLE_KEY, role);
    return true;
  } catch (error) {
    console.error('Error saving token:', error);
    return false;
  }
}

// export function getToken() {
//   try {
//     return sessionStorage.getItem(TOKEN_KEY);
//   } catch (error) {
//     console.error('Error getting token:', error);
//     return null;
//   }
// }

export function getAccessToken() {
  return sessionStorage.getItem(ACCESS_TOKEN_KEY);
}

export function getRefreshToken() {
  return sessionStorage.getItem(REFRESH_TOKEN_KEY);
}

export function getUsername() {
  try {
    return sessionStorage.getItem(USERNAME_KEY);
  } catch (error) {
    console.error('Error getting username:', error);
    return null;
  }
}

export function getUserRole() {
  try {
    return sessionStorage.getItem(ROLE_KEY);
  } catch (error) {
    console.error('Error getting user role:', error);
    return null;
  }
}

export function isAuthenticated() {
  return getAccessToken() !== null;
}

export function logout() {
  try {
    sessionStorage.removeItem(ACCESS_TOKEN_KEY);
    sessionStorage.removeItem(REFRESH_TOKEN_KEY);
    sessionStorage.removeItem(USERNAME_KEY);
    sessionStorage.removeItem(ROLE_KEY);
    return true;
  } catch (error) {
    console.error('Error during logout:', error);
    return false;
  }
}

// RSA public-key encryption, replacing the old shared-secret AES scheme.
// Only the backend, holding the matching private key (RSA_PRIVATE_KEY), can
// decrypt this - the public key here is safe to ship in the built bundle.
// JSEncrypt uses PKCS#1 v1.5 padding - the backend's crypto.privateDecrypt
// must use the matching padding option or decryption will fail.
const RSA_PUBLIC_KEY = process.env.VUE_APP_RSA_PUBLIC_KEY
  ? process.env.VUE_APP_RSA_PUBLIC_KEY.replace(/\\n/g, '\n')
  : undefined;

export const encryptRSA = (data) => {
  if (!RSA_PUBLIC_KEY) {
    throw new Error('VUE_APP_RSA_PUBLIC_KEY is not configured');
  }
  const encryptor = new JSEncrypt();
  encryptor.setPublicKey(RSA_PUBLIC_KEY);
  const encrypted = encryptor.encrypt(data);
  if (encrypted === false) {
    throw new Error('RSA encryption failed');
  }
  return encrypted;
};